import { createBrowserRouter } from "react-router-dom";
import MainLayout from "./../components/ui-components/layout/MainLayout";
import QuestionLayout from "./../components/ui-components/layout/QuestionLayout";

// pages
import Declaration from "./../components/pages/Declaration";
import Start from "./../components/pages/Start";
import Info from "./../components/pages/Info";
import LearnerForm from "./../components/pages/LearnerForm";
import Instructions from "./../components/pages/Instructions";
import Complete from "./../components/pages/Complete";
import Error from "./../components/pages/Error";
import ErrorWithHeader from "./../components/pages/Error/ErrorWithHeader";
import ModuleBreak from "./../components/pages/ModuleBreak";
import Resume from "./../components/pages/Resume";
import Disabled from "../components/pages/Disabled";
import DisabledQuizType from "../components/pages/DisabledQuizType";

// questions
import Question from "./../components/pages/Questions";

const publicUrl = process.env.PUBLIC_URL;

const router = createBrowserRouter([
	{
		path: publicUrl,
        errorElement: <ErrorWithHeader />,
		element: <MainLayout />,
        children: [
            {
                path: publicUrl,
                element: <Start />
            },
            {
                path: `${publicUrl}/info`,
                element: <Info />
            },
            {
                path: `${publicUrl}/form`,
                element: <LearnerForm />
            },
            {
                path: `${publicUrl}/declaration`,
                element: <Declaration />
            },
            {
                path: `${publicUrl}/instructions`,
                element: <Instructions />
            },
            {
                path: `${publicUrl}/complete`,
                element: <Complete />
            },
            {
                path: `${publicUrl}/error`,
                element: <Error />
            },
            {
                path: `${publicUrl}/continue`,
                element: <ModuleBreak />
            },
            {
                path: `${publicUrl}/resume`,
                element: <Resume />
            },
            {
                path: `${publicUrl}/disabled`,
                element: <Disabled />
            },
            {
                path: `${publicUrl}/disabledquiztype`,
                element: <DisabledQuizType />
            },
        ]
	},
    {
        path: `${publicUrl}/question`,
		element: <QuestionLayout />,
        errorElement: <ErrorWithHeader />,
        children: [
            {
                path: `${publicUrl}/question/`,
                element: <Question />,
            }
        ]
	},
    // {
    //     path: `${publicUrl}/web`,
	// 	element: <WebLayout />,
    //     children: [
    //         {
    //             path: `${publicUrl}/web`,
    //             element: <WebQuestions />
    //         }
    //     ]
	// },
], {
    basename: process.env.REACT_APP_BASE_NAME
});

export default router;
